module.exports = __webpack_public_path__ + "img/pass.56f38adb.png";